<template>
  <div class="information-box">
    <div class="information-box__textwrap">
      <af-h2 noMarginTop>
        <slot name="title"></slot>
      </af-h2>
      <p class="information-box__content">
        <slot name="content"></slot>
      </p>
      <af-link v-if="linkUrl" :href="linkUrl" :target="linkTarget">
        <template slot="link">
          <slot name="link"></slot>  
        </template>
      </af-link> 
    </div>
    <img class="information-box__image" :src="image" />
  </div>
</template>

<script>
import AfH2 from '@/components/AfH2'
import AfLink from '@/components/AfLink'

export default {
  name: 'af-information-box',

  components: {
    AfH2,
    AfLink
  },

  props: {
    image: String,
    linkUrl: String,
    linkTarget: String
  }
}
</script>

<style lang="postcss" scoped>
@import '../variables/custom-media.css';

.information-box {
  align-items: flex-start;
  background-color: var(--color-white);
  border-radius: 4px;
  display: flex;
  padding: 20px;

  @media (--bp-med) {
    &:not(:last-child) {
      margin-bottom: var(--spacing-medium);
    }
  }

  @media (--bp-desktop) {
    padding: var(--spacing-large) 40px;
    width: 48.5%;
  }
}

.information-box__textwrap {
  @media (--ie11) {
    max-width: 315px;
  }
}

.information-box__image {
  align-self: center;
  display: none;
  margin-left: var(--spacing);
  max-width: 125px;

  @media (--bp-larger-than-tablet) {
    display: block;
  }
}

.information-box__title {
  font-weight: 300;
  font-size: 26px;
  margin-top: 0;
}


.information-box__link {
  align-items: center;
  display: flex;
  font-weight: 600;
  text-decoration: none;
}

.information-box__link-icon {
  margin-right: 7px;
}
</style>



// WEBPACK FOOTER //
// src/components/AfInformationBox.vue